import gsap from 'gsap'
import { updateFrames } from './anime'

function frame_points(points, target) {

    // Vars
    let pos = 0;
    let block = false; // Disable click on active animation
    let obj = {
        value: 0
    };

    // Click on point
    const play_to = (pos_from, pos_to, done, position) => {
        if (!block) {
            block = true
            updateFrames(target, {
                value: pos_from
            })
            gsap.fromTo(obj, {
                value: pos_from
            },
                {
                    value: pos_to,
                    duration: 1,
                    onUpdate: function () {
                        updateFrames(target, obj);
                    },
                    onComplete: () => {
                        if (done) {
                            obj.value = 0
                            updateFrames(target, obj)
                        }
                        pos = position
                        console.log(pos)
                        block = false
                    }
                })
        }
    }

    // Click on first btn
    $('#play_geometry_1').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 0:
                play_to(zero_in_p1.from, zero_in_p1.to * 0.98, false, 1)
                break;
            case 2:
                play_to(p1_in_p2.to, p1_in_p2.from * 1.02, false, 1)
                break;
            case 3:
                play_to(p1_in_p3.to, p1_in_p3.from * 1.02, false, 1)
                break;
            case 1:
                play_to(zero_in_p1.to, zero_in_p1.from, false, 0)
                break;
        }
    })

    // Click on second btn
    $('#play_geometry_2').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 0:
                play_to(zero_in_p2.from, zero_in_p2.to, false, 2)
                break;
            case 2:
                play_to(zero_in_p2.to, zero_in_p2.from, false, 0)
                break;
            case 3:
                play_to(p2_in_p3.to, p2_in_p3.from * 1.01, false, 2)
                break;
            case 1:
                play_to(p1_in_p2.from, p1_in_p2.to, false, 2)
                break;
        }
    })

    // Click on third btn
    $('#play_geometry_3').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 0:
                play_to(zero_in_p3.from, zero_in_p3.to, false, 3)
                break;
            case 2:
                play_to(p2_in_p3.from * 1.01, p2_in_p3.to, false, 3)
                break;
            case 3:
                play_to(zero_in_p3.to, zero_in_p3.from * 1.02, false, 0)
                break;
            case 1:
                play_to(p1_in_p3.from * 1.02, p1_in_p3.to, false, 3)
                break;
        }
    })

    $('#frame-canvas').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 2:
                play_to(zero_in_p2.to, zero_in_p2.from, false, 0)
                break;
            case 3:
                play_to(zero_in_p3.to, zero_in_p3.from * 1.02, false, 0)
                break;
            case 1:
                play_to(zero_in_p1.to, zero_in_p1.from, false, 0)
                break;
        }
    })
}

export {
    frame_points
}